import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const DescriptionPage = lazy(() => import('./description-page'));

const Description = () => {
  return (
    <LazyRoute>
      <DescriptionPage />
    </LazyRoute>
  );
};

export { Description };
